import { fetchItemSummariesIfNeeded } from '@/redux/modules/item/summary/itemSummary.actions';
import { fetchRecommendedItemIfNeeded, getSortedRecommendedItemIdsFromState } from '@/redux/modules/recommendedItem';
import {
    fetchRecommendedSimilarItems,
    getRecommendedSimilarItemIdsFromState,
} from '@/redux/modules/recommendedSimilarItems';
import { DataLoaderParams } from '@/types/DataLoaderParams';
import { AmplitudeExperiments, AmplitudeVariants } from '@/utils/amplitude/experiments/AmplitudeExperiments';

export default ({ amplitudeExperimentFlags, match, store }: DataLoaderParams) => {
    const { dispatch, getState } = store;
    const {
        params: { amazon },
    } = match;
    const replaceRecommendedItemsWithSimilarLotsVariant =
        amplitudeExperimentFlags[AmplitudeExperiments.ReplaceRecommendedItemsWithSimilarLots]?.value;
    const hasLastTwoViewedLots =
        replaceRecommendedItemsWithSimilarLotsVariant ===
        AmplitudeVariants.ReplaceRecommendedItemsWithSimilarLots.LastTwoViewedLots;
    const hasLastTwoSavedLots =
        replaceRecommendedItemsWithSimilarLotsVariant ===
        AmplitudeVariants.ReplaceRecommendedItemsWithSimilarLots.LastTwoSavedLots;
    const shouldUseRecommendedSimilarItems = hasLastTwoViewedLots || hasLastTwoSavedLots;

    const fetchRecommendedItems = shouldUseRecommendedSimilarItems
        ? dispatch(
              fetchRecommendedSimilarItems({
                  shouldUseLastTwoSavedLots: hasLastTwoSavedLots,
                  shouldUseLastTwoViewedLots: hasLastTwoViewedLots,
              })
          )
        : dispatch(fetchRecommendedItemIfNeeded(Boolean(amazon)));

    return fetchRecommendedItems.then(() => {
        const state = getState();
        const itemIds = shouldUseRecommendedSimilarItems
            ? getRecommendedSimilarItemIdsFromState(state, 0)
            : getSortedRecommendedItemIdsFromState(state, 0);
        return dispatch(
            fetchItemSummariesIfNeeded({
                identifier: 'RECOMMENDED-ITEMS-PAGE',
                itemIds,
            })
        );
    });
};
